import type React from 'react'
import type { IEpisode, IPlaylistPopoverControls, ISeason } from '../Playlist.h'

import { useCallback } from 'react'
import { setFullContent } from '../lib'
import { PlaylistPopoverMenuItems } from '../Playlist.h'

export const usePlaylistPopoverControls = ({
  setActiveTab,
  setIsBottomNotReached,
  setActiveEpisode,
  setActiveSeason,
  setIsTopNotReached,
  activeSeason,
  activeTab,
  isSeasons,
  playlist,
  onClose,
}: IPlaylistPopoverControls) => {
  const { playEpisode, seasonsWithEpisodes, currentEpisode } = playlist || {}

  const closePopover = (event?: React.MouseEvent<Element, MouseEvent>) => {
    event?.stopPropagation()
    setActiveTab(PlaylistPopoverMenuItems.Default)
    setActiveSeason(undefined)
    setActiveEpisode(undefined)
    onClose?.()
  }

  const handleScroll = useCallback(
    (e: React.UIEvent<HTMLDivElement>) => {
      const currentTarget = e.currentTarget
      const scrollTop = currentTarget.scrollTop

      setIsTopNotReached(scrollTop > 1)

      const isScrolledToBottom =
        currentTarget.scrollHeight - scrollTop - currentTarget.clientHeight > 1
      setIsBottomNotReached(isScrolledToBottom)
    },
    [setIsBottomNotReached, setIsTopNotReached]
  )

  const playOtherEpisode = useCallback(
    ({ episodeId, seasonId }: { episodeId?: number; seasonId?: number }) => {
      if (!playEpisode) return

      playEpisode({ seasonId: seasonId, episodeId: Number(episodeId) })
      // updatePlaylistPopoverState(false)
      onClose?.()
    },
    [playEpisode, onClose]
  )
  const handleSeasonClick = (
    e: React.MouseEvent<HTMLButtonElement, MouseEvent>,
    season: ISeason
  ): void => {
    e.stopPropagation()
    setActiveSeason(season)
    setActiveTab(PlaylistPopoverMenuItems.Episodes)
  }

  const handleEpisodeClick = (
    e: React.MouseEvent<HTMLButtonElement, MouseEvent>,
    episode: IEpisode
  ): void => {
    e.stopPropagation()
    // hide popover at tablets and phones after selection
    setActiveEpisode(episode)
    setActiveTab(
      isSeasons
        ? PlaylistPopoverMenuItems.Episodes
        : PlaylistPopoverMenuItems.Default
    )
    playOtherEpisode({ episodeId: episode.id, seasonId: activeSeason?.id })
  }

  const returnToPrevTab = (
    event?: React.MouseEvent<Element, MouseEvent>
  ): void => {
    event?.stopPropagation()
    if (activeTab === PlaylistPopoverMenuItems.Episodes) {
      setActiveTab(
        isSeasons
          ? PlaylistPopoverMenuItems.Seasons
          : PlaylistPopoverMenuItems.Default
      )
      setFullContent({
        seasonsWithEpisodes,
        setActiveEpisode,
        setActiveSeason,
        currentEpisode,
      })
    }
  }

  return {
    closePopover,
    handleSeasonClick,
    returnToPrevTab,
    handleScroll,
    handleEpisodeClick,
  }
}
